import { render, staticRenderFns } from "./PresentationList.vue?vue&type=template&id=4ae0d027&"
import script from "./PresentationList.vue?vue&type=script&lang=js&"
export * from "./PresentationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports